import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { EditProfileComponent } from './edit-profile.component';
import { EditProfileResolve } from './edit-profile.resolve';
import { CheckboxQuestionListComponent } from '../../../shared/checkbox-list/checkbox-question-list.component';
import { AddressModule } from '../captain/address/address.module';
import { AvailabilityModule } from '../captain/availability/availability.module';
import { ProfilePhotoModule } from '../profile-photo/profile-photo.module';
import { UploadSinglePhotoModule } from '../../../shared/upload/upload-single-photo/upload-single-photo.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CaptainDeletionRequestModule } from '../../../captain/captain-deletion-request/captain-deletion-request.module';
import { MatRadioModule } from '@angular/material/radio';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { PaymentMethodManagerModule } from '../../../shared/payment-method-manager/payment-method-manager.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    ListGridModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    MatCheckboxModule,
    MatIconModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    AddressModule,
    AvailabilityModule,
    ProfilePhotoModule,
    UploadSinglePhotoModule,
    ImageCropperModule,
    CaptainDeletionRequestModule,
    MatRadioModule,
    ReactiveFormsModule,
    LoadingModule,
    PaymentMethodManagerModule,
  ],
  declarations: [EditProfileComponent],
  entryComponents: [CheckboxQuestionListComponent],
  exports: [EditProfileComponent],
  providers: [EditProfileResolve],
})
export class EditProfileModule {}
